const en_US = {
  placeholderText: "Please enter",
  closeContentText: "Confirm ending the current conversation?",
  cancelText: "Cancel",
  okText: "Sure",
  loadingAnswerQuestions:
    "Answering your last question, please wait to submit.",
  networkAnomalyText: "Network error, please try again later.",
  messageTooShort: "The question requires at least 2 words",
  messageTooLong: "The question cannot exceed 200 words",
  messageCannotBeEmpty: "The question cannot be empty",
  systemErrorText: "system error",
};
export default en_US;
